/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".person-roles[_ngcontent-%COMP%]{display:flex;justify-content:space-between}.person-roles[_ngcontent-%COMP%]   .text-muted[_ngcontent-%COMP%]{margin-left:10px;color:#ccc}@media only screen and (min-width:769px){.delete-contact[_ngcontent-%COMP%]{margin-top:29px;color:red;font-size:1.5em}}"];
export { styles as styles };
